/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createRequirement = /* GraphQL */ `
  mutation CreateRequirement(
    $input: CreateRequirementInput!
    $condition: ModelRequirementConditionInput
  ) {
    createRequirement(input: $input, condition: $condition) {
      id
      formulaId
      nep
      userId
      details
      name
      orders {
        items {
          id
          RequirementId
          userId
          totalHT
          products
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateRequirement = /* GraphQL */ `
  mutation UpdateRequirement(
    $input: UpdateRequirementInput!
    $condition: ModelRequirementConditionInput
  ) {
    updateRequirement(input: $input, condition: $condition) {
      id
      formulaId
      nep
      userId
      details
      name
      orders {
        items {
          id
          RequirementId
          userId
          totalHT
          products
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteRequirement = /* GraphQL */ `
  mutation DeleteRequirement(
    $input: DeleteRequirementInput!
    $condition: ModelRequirementConditionInput
  ) {
    deleteRequirement(input: $input, condition: $condition) {
      id
      formulaId
      nep
      userId
      details
      name
      orders {
        items {
          id
          RequirementId
          userId
          totalHT
          products
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLetters = /* GraphQL */ `
  mutation CreateLetters(
    $input: CreateLettersInput!
    $condition: ModelLettersConditionInput
  ) {
    createLetters(input: $input, condition: $condition) {
      id
      code
      condition
      LettersSubThemes {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLetters = /* GraphQL */ `
  mutation UpdateLetters(
    $input: UpdateLettersInput!
    $condition: ModelLettersConditionInput
  ) {
    updateLetters(input: $input, condition: $condition) {
      id
      code
      condition
      LettersSubThemes {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLetters = /* GraphQL */ `
  mutation DeleteLetters(
    $input: DeleteLettersInput!
    $condition: ModelLettersConditionInput
  ) {
    deleteLetters(input: $input, condition: $condition) {
      id
      code
      condition
      LettersSubThemes {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createTheme = /* GraphQL */ `
  mutation CreateTheme(
    $input: CreateThemeInput!
    $condition: ModelThemeConditionInput
  ) {
    createTheme(input: $input, condition: $condition) {
      id
      ref
      name
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateTheme = /* GraphQL */ `
  mutation UpdateTheme(
    $input: UpdateThemeInput!
    $condition: ModelThemeConditionInput
  ) {
    updateTheme(input: $input, condition: $condition) {
      id
      ref
      name
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteTheme = /* GraphQL */ `
  mutation DeleteTheme(
    $input: DeleteThemeInput!
    $condition: ModelThemeConditionInput
  ) {
    deleteTheme(input: $input, condition: $condition) {
      id
      ref
      name
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSubTheme = /* GraphQL */ `
  mutation CreateSubTheme(
    $input: CreateSubThemeInput!
    $condition: ModelSubThemeConditionInput
  ) {
    createSubTheme(input: $input, condition: $condition) {
      id
      ref
      title
      isSub
      parentId
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      letters {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSubTheme = /* GraphQL */ `
  mutation UpdateSubTheme(
    $input: UpdateSubThemeInput!
    $condition: ModelSubThemeConditionInput
  ) {
    updateSubTheme(input: $input, condition: $condition) {
      id
      ref
      title
      isSub
      parentId
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      letters {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSubTheme = /* GraphQL */ `
  mutation DeleteSubTheme(
    $input: DeleteSubThemeInput!
    $condition: ModelSubThemeConditionInput
  ) {
    deleteSubTheme(input: $input, condition: $condition) {
      id
      ref
      title
      isSub
      parentId
      Languages {
        items {
          id
          code
          label
          themeID
          subthemeID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      letters {
        items {
          id
          subthemeID
          lettersID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLanguage = /* GraphQL */ `
  mutation CreateLanguage(
    $input: CreateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    createLanguage(input: $input, condition: $condition) {
      id
      code
      label
      themeID
      subthemeID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLanguage = /* GraphQL */ `
  mutation UpdateLanguage(
    $input: UpdateLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    updateLanguage(input: $input, condition: $condition) {
      id
      code
      label
      themeID
      subthemeID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLanguage = /* GraphQL */ `
  mutation DeleteLanguage(
    $input: DeleteLanguageInput!
    $condition: ModelLanguageConditionInput
  ) {
    deleteLanguage(input: $input, condition: $condition) {
      id
      code
      label
      themeID
      subthemeID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createLettersSubTheme = /* GraphQL */ `
  mutation CreateLettersSubTheme(
    $input: CreateLettersSubThemeInput!
    $condition: ModelLettersSubThemeConditionInput
  ) {
    createLettersSubTheme(input: $input, condition: $condition) {
      id
      subthemeID
      lettersID
      subtheme {
        id
        ref
        title
        isSub
        parentId
        Languages {
          nextToken
          startedAt
        }
        letters {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      letters {
        id
        code
        condition
        LettersSubThemes {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateLettersSubTheme = /* GraphQL */ `
  mutation UpdateLettersSubTheme(
    $input: UpdateLettersSubThemeInput!
    $condition: ModelLettersSubThemeConditionInput
  ) {
    updateLettersSubTheme(input: $input, condition: $condition) {
      id
      subthemeID
      lettersID
      subtheme {
        id
        ref
        title
        isSub
        parentId
        Languages {
          nextToken
          startedAt
        }
        letters {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      letters {
        id
        code
        condition
        LettersSubThemes {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteLettersSubTheme = /* GraphQL */ `
  mutation DeleteLettersSubTheme(
    $input: DeleteLettersSubThemeInput!
    $condition: ModelLettersSubThemeConditionInput
  ) {
    deleteLettersSubTheme(input: $input, condition: $condition) {
      id
      subthemeID
      lettersID
      subtheme {
        id
        ref
        title
        isSub
        parentId
        Languages {
          nextToken
          startedAt
        }
        letters {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      letters {
        id
        code
        condition
        LettersSubThemes {
          nextToken
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFormula = /* GraphQL */ `
  mutation CreateFormula(
    $input: CreateFormulaInput!
    $condition: ModelFormulaConditionInput
  ) {
    createFormula(input: $input, condition: $condition) {
      id
      userId
      name
      ingredients
      requirements {
        items {
          id
          formulaId
          nep
          userId
          details
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFormula = /* GraphQL */ `
  mutation UpdateFormula(
    $input: UpdateFormulaInput!
    $condition: ModelFormulaConditionInput
  ) {
    updateFormula(input: $input, condition: $condition) {
      id
      userId
      name
      ingredients
      requirements {
        items {
          id
          formulaId
          nep
          userId
          details
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFormula = /* GraphQL */ `
  mutation DeleteFormula(
    $input: DeleteFormulaInput!
    $condition: ModelFormulaConditionInput
  ) {
    deleteFormula(input: $input, condition: $condition) {
      id
      userId
      name
      ingredients
      requirements {
        items {
          id
          formulaId
          nep
          userId
          details
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      RequirementId
      userId
      totalHT
      products
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      id
      RequirementId
      userId
      totalHT
      products
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      id
      RequirementId
      userId
      totalHT
      products
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFlexibleFeatures = /* GraphQL */ `
  mutation CreateFlexibleFeatures(
    $input: CreateFlexibleFeaturesInput!
    $condition: ModelFlexibleFeaturesConditionInput
  ) {
    createFlexibleFeatures(input: $input, condition: $condition) {
      id
      title
      atex
      continuite_electrique
      fda
      wras
      bfr
      ce_1935_2004
      ce_2023_2006
      simulantA
      simulantB
      simulantC
      simulantD1
      simulantD2
      simulantE
      usp_class_6
      agrement_bnic
      alcool95
      eau_chaude
      vapeur
      acide_nitrique
      acide_phosphorique
      composes_chlores
      hydroxyde_sodium
      peroxyde_hydrogene
      acide_paracetique
      pression_service
      depression
      souplesse
      legerete
      accepte_ecrasement_accidentel
      temperatureMin
      temperatureMax
      productsCodes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFlexibleFeatures = /* GraphQL */ `
  mutation UpdateFlexibleFeatures(
    $input: UpdateFlexibleFeaturesInput!
    $condition: ModelFlexibleFeaturesConditionInput
  ) {
    updateFlexibleFeatures(input: $input, condition: $condition) {
      id
      title
      atex
      continuite_electrique
      fda
      wras
      bfr
      ce_1935_2004
      ce_2023_2006
      simulantA
      simulantB
      simulantC
      simulantD1
      simulantD2
      simulantE
      usp_class_6
      agrement_bnic
      alcool95
      eau_chaude
      vapeur
      acide_nitrique
      acide_phosphorique
      composes_chlores
      hydroxyde_sodium
      peroxyde_hydrogene
      acide_paracetique
      pression_service
      depression
      souplesse
      legerete
      accepte_ecrasement_accidentel
      temperatureMin
      temperatureMax
      productsCodes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFlexibleFeatures = /* GraphQL */ `
  mutation DeleteFlexibleFeatures(
    $input: DeleteFlexibleFeaturesInput!
    $condition: ModelFlexibleFeaturesConditionInput
  ) {
    deleteFlexibleFeatures(input: $input, condition: $condition) {
      id
      title
      atex
      continuite_electrique
      fda
      wras
      bfr
      ce_1935_2004
      ce_2023_2006
      simulantA
      simulantB
      simulantC
      simulantD1
      simulantD2
      simulantE
      usp_class_6
      agrement_bnic
      alcool95
      eau_chaude
      vapeur
      acide_nitrique
      acide_phosphorique
      composes_chlores
      hydroxyde_sodium
      peroxyde_hydrogene
      acide_paracetique
      pression_service
      depression
      souplesse
      legerete
      accepte_ecrasement_accidentel
      temperatureMin
      temperatureMax
      productsCodes
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createWordpress = /* GraphQL */ `
  mutation CreateWordpress(
    $input: CreateWordpressInput!
    $condition: ModelWordpressConditionInput
  ) {
    createWordpress(input: $input, condition: $condition) {
      id
      userId
      wordpressUserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateWordpress = /* GraphQL */ `
  mutation UpdateWordpress(
    $input: UpdateWordpressInput!
    $condition: ModelWordpressConditionInput
  ) {
    updateWordpress(input: $input, condition: $condition) {
      id
      userId
      wordpressUserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteWordpress = /* GraphQL */ `
  mutation DeleteWordpress(
    $input: DeleteWordpressInput!
    $condition: ModelWordpressConditionInput
  ) {
    deleteWordpress(input: $input, condition: $condition) {
      id
      userId
      wordpressUserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
